import React from "react";
import styled from "styled-components";
import { FontSize, content, transparentize } from "@glossy";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { getStep } from "./model";

interface IProps {
  password?: string;
  locale: Locale;
}

const Root = styled.div`
  font-size: ${FontSize.Medium};
`;

const Track = styled.div`
  background-color: ${(props) =>
    transparentize(0.85, content(props, "primary"))};
`;

const Bar = styled.div`
  height: 10px;
`;

const UiKitPasswordStrength = ({ password, locale }: IProps) => {
  const { label, percent, color } = getStep(password);
  return (
    <Root>
      <div>{tr(locale, label)}</div>
      <Track>
        <Bar style={{ width: percent + "%", backgroundColor: color }} />
      </Track>
    </Root>
  );
};

export default UiKitPasswordStrength;
